import React from 'react';
import { volumes } from '../data/slojd';

// Neutral CSS placeholders, only shown if an image slot in data/slojd.ts is empty.
export function ProductBoxPlaceholder({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="SLÖJDKLAR™ – 6 digitala volymer i slöjd för åk 1–9" className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-263" data-mp="1eth6zrwbbtw5">
      <div className="rounded-2xl bg-[#1B2A5E] p-5 text-white shadow-2xl shadow-slate-900/30" data-id="element-264" data-mp="19tlb6fxrr8ro">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70" data-id="element-265" data-mp="15rhmgpm3a7og">Åk 1–9 · Lgr22</p>
        <p className="mt-1 font-serif text-4xl leading-none tracking-tight" data-id="element-266" data-mp="10x3xp61xmysr">SLÖJDKLAR<span className="align-super text-[0.45em]" data-id="element-267" data-mp="vvwrhbffu7o7">™</span></p>
        <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-268" data-mp="qxd5xc4raxwd">Textil · Trä · Metall</p>
        <div className="mt-5 grid grid-cols-6 gap-1.5" data-id="element-269" data-mp="2qa7edech2rrc">
          {volumes.map(v => <div key={v.number} className={`flex h-36 flex-col justify-between rounded-md border-r-4 border-black/10 p-1.5 ${v.spine}`} data-id="element-270" data-mp="2lal3hbk49nlp">
              <span className="text-[9px] font-bold opacity-80" data-id="element-271" data-mp="2t5ctafn79i4i">{v.number.replace('Volym ', 'V')}</span>
            </div>)}
        </div>
        <p className="mt-4 text-center text-sm font-semibold text-[#FECC02]" data-id="element-272" data-mp="2y6sh2fgri2ql">6 volymer + 5 bonusar</p>
      </div>
    </div>;
}
export function PagePlaceholder({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <div className="flex h-full w-full flex-col bg-white" aria-hidden="true" data-id="element-273" data-mp="2o94j7gnv0f47">
      <div className="flex items-center justify-between bg-[#1B2A5E] px-4 py-3 text-white" data-id="element-274" data-mp="3bxnqptz34nv8">
        <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-275" data-mp="3gvfkktjaik22">SLÖJDKLAR™</span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-276" data-mp="326ssdr8kdxtf">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#2BB673]" data-id="element-277" data-mp="375nile8v2onk">{label}</p>
        <p className="font-serif text-xl leading-tight text-slate-900" data-id="element-278" data-mp="3uv84a4weg00j">{title}</p>
      </div>
    </div>;
}